
<style lang="scss" scoped>
@import "~@/css/common";

$headerHeight: 45px;
.content {
  header {
    width: 100%;
    // height: $headerHeight;
    background: #e0eaf6;
    .content2 {
      display: flex;
      .logo {
        img {
          padding-top: 5px;
          width: 100%;
          height: 90%;
        }
      }
      .nav-warp {
        display: flex;
        margin-left: auto;
        .nav-item {
          line-height: $headerHeight;
          padding: 0 15px;
          cursor: pointer;
          &:hover,
          &.act {
            border-bottom: 4px solid #016cff;
            transition: 0.2s;
          }
        }
      }
    }
  }
  .base-warp {
    position: absolute;
    left: 0;
    top: $headerHeight;
    width: 100%;
    height: calc(100% - #{$headerHeight});
    // overflow: hidden;
    .center {
      min-width: $MINW;
      margin: 0 auto;
      height: 100%;
      display: flex;
      .menu-warp {
        width: 300px;
        padding: 25px;
      }
      .router-warp {
        flex: 1;
        padding: 25px 0;
        padding-right: 10px;
        overflow: hidden;
        overflow-y: auto;
      }
    }
  }
}
.content2 {
  margin: 0 auto;
  height: $headerHeight !important;
  width: 1024px !important;
}
.nav {
  position: relative;
}
.logoImg {
  height: 2.625rem;
}
.menuItem {
  font-size: 1rem;
  color: #000000;
  margin-left: 2rem;
  font-weight: 600;
}
.menuItem.active {
  color: #3581ff;
}
</style>
<template>
  <div class="content">
    <header style="padding: 8px 0">
      <div class="flex justify-between nav mainContent">
        <div class="cursor-pointer flex items-center">
          <img
            src="@/assets/imgs/footer/footerLogo.jpg"
            alt=""
            class="logoImg"
            @click="clickLogo"
          /><span style="font-size: 24px; margin-left: 6px; font-weight: bold"
            >易回复</span
          >
        </div>
        <div class="flex items-center">
          <div class="flex items-center">
            <div
              @click="actdNav(nav)"
              ref="nav"
              class="menuItem cursor-pointer"
              v-for="nav in navs"
              :key="nav.label"
            >
              {{ nav.label }}
            </div>
            <div
              v-if="userInfo.userId"
              class="menuItem cursor-pointer active"
              @click="toIndex"
            >
              控制台
            </div>
            <div class="menuItem cursor-pointer" v-if="userInfo.userId">
              <Poptip trigger="hover" title="更多操作">
                <a style="padding: 0 8px">{{ userInfo.nickname }}</a>
                <template #content>
                  <div><a @click="toUserCenter">个人中心</a></div>
                  <div style="margin-top: 12px">
                    <a @click="toUserCenterChangePassword">修改密码</a>
                  </div>
                  <div style="margin-top: 12px">
                    <a style="color: #ed4014" @click="logout">注销</a>
                  </div>
                </template>
              </Poptip>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="content2">
        <div class="logo">
          <img src="@/assets/logo.png" />
        </div>
        <div class="nav-warp">
          <div
            @click="actdNav(nav)"
            class="nav-item"
            :class="{ act: actNav.label === nav.label }"
            v-for="nav in navs"
            :key="nav.label"
          >
            {{ nav.label }}
          </div>
          <div v-if="!userInfo.userId" @click="login" class="nav-item">
            登陆
          </div>
          <div v-if="userInfo.userId" class="nav-item act" @click="toIndex">
            <a>控制台</a>
          </div>
          <div class="nav-item" v-if="userInfo.userId">
            <Poptip trigger="hover" title="更多操作">
              <a style="padding: 0 8px">{{ userInfo.nickname }}</a>
              <template #content>
                <div><a @click="toUserCenter">个人中心</a></div>
                <div><a @click="toUserCenterChangePassword">修改密码</a></div>
                <div><a style="color: #ed4014" @click="logout">注销</a></div>
              </template>
            </Poptip>
          </div>
        </div>
      </div> -->
    </header>

    <div class="base-warp">
      <div class="center">
        <div class="menu-warp">
          <Menu :active-name="1" @on-select="menuClick">
            <MenuGroup :title="menu.label" v-for="menu in menus" :key="menu.id">
              <MenuItem
                v-show="item.showFn ? item.showFn(userInfo) : true"
                :to="item.name"
                :name="item.id"
                v-for="item in menu.child"
                :key="item.id"
              >
                <Icon type="md-document" />
                {{ item.label }}
              </MenuItem>
            </MenuGroup>
          </Menu>
        </div>
        <div class="router-warp">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import userService from "@/service/user";
export default {
  name: "UserCenter",
  data() {
    let origin = window.location.origin;
    let chromeCheck = origin.includes("www.traneasy.vip");
    return {
      userInfo: {},
      // navs: [
      //     {label: "首页", img: require("@/assets/bg/home.png"),component:"Home"},
      //     {label: "定价标准", img: require("@/assets/bg/price.png"),component:"Price"},
      //     {label: "使用文档", img: require("@/assets/bg/doc.png"),component:"Doc"},
      //     {label: "联系我们", img: require("@/assets/bg/home.png"),component:"Home"},
      // ],
      navs: !chromeCheck
        ? [
            {
              label: "首页",
              img: require("@/assets/bg/home.png"),
              component: "Home",
            },
            {
              label: "定价标准",
              img: require("@/assets/bg/price.png"),
              component: "price",
            },
            {
              label: "软件下载",
              img: require("@/assets/bg/home.png"),
              component: "download",
            },
          ]
        : [
            {
              label: "首页",
              img: require("@/assets/bg/home.png"),
              component: "Home",
            },
            {
              label: "定价标准",
              img: require("@/assets/bg/price.png"),
              component: "price",
            },
            {
              label: "软件下载",
              img: require("@/assets/bg/home.png"),
              component: "download",
            },
            {
              label: "使用文档",
              img: require("@/assets/bg/doc.png"),
              component: "useDoc",
            },
          ],
      actNav: {},
      menus: [
        {
          id: 1,
          label: "会员中心",
          child: [
            { id: 2, label: "会员中心", icon: "", name: "UserCenterIndex" },
            { id: 3, label: "个人资料", icon: "", name: "UserCenterInfo" },
            {
              id: 4,
              label: "修改密码",
              icon: "",
              name: "UserCenterChangePassword",
            },
            { id: 5, label: "登陆记录", icon: "", name: "UserCenterLoginLog" },
            // {
            //   id: 6,
            //   label: "子账户管理",
            //   icon: "",
            //   name: "UserCenterChild",
            //   showFn: (userInfo) => {
            //     if (userInfo.parentUserId) {
            //       return false;
            //     }
            //     return true;
            //   },
            // },
          ],
        },
        {
          id: 11,
          label: "功能管理",
          child: [
            {
              id: 12,
              label: "充值",
              icon: "",
              name: "UserCenterRecharge",
              showFn: (userInfo) => {
                if (userInfo.parentUserId) {
                  return false;
                }
                return true;
              },
            },
            {
              id: 13,
              label: "充值订单",
              icon: "",
              name: "UserCenterOrder",
              showFn: (userInfo) => {
                if (userInfo.parentUserId) {
                  return false;
                }
                return true;
              },
            },
            // {
            //   id: 14,
            //   label: "账户日志",
            //   icon: "",
            //   name: "UserCenterAccountLog",
            // },
            {
              id: 15,
              label: "翻译日志",
              icon: "",
              name: "UserCenterChangeTranslateLog",
            },
            {
              id: 16,
              label: "翻译测试",
              icon: "",
              name: "UserCenterChangeTranslateTest",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.init();
    this.FLUSH_TRAN_CHANNEL();
  },
  methods: {
    ...mapActions(["FLUSH_TRAN_CHANNEL"]),
    async init() {
      this.userInfo = await userService.get();
    },
    selectedNav(nav) {
      this.go(nav);
    },
    go(nav) {
      let { url } = nav;
      if (!url) {
        this.toIndex();
        return;
      }
      window.open(url, nav.target);
    },
    toIndex() {
      this.$router.push({ name: "Index" });
    },
    toUserCenter() {
      this.$router.push({ name: "UserCenterIndex" });
    },
    toUserCenterChangePassword() {
      this.$router.push({ name: "UserCenterChangePassword" });
    },
    logout() {
      this.userInfo = {};
      sessionStorage.removeItem("sk");
      sessionStorage.removeItem("userInfo");
      this.$router.push({ name: "Index" });
    },
    actdNav(nav) {
      this.$router.push({ name: "Index", query: { act: nav.label } });
    },
    menuClick() {},
  },
};
</script>
